// src/utils/editor/DragColumnResizer.js
import React, { useEffect, useRef } from 'react';

const DragColumnResizer = ({ containerRef, leftColumnWidth, setLeftColumnWidth }) => {
  const isDragging = useRef(false);

  const handleMouseDown = (e) => {
    e.preventDefault();
    isDragging.current = true; // Begin dragging
  };

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!isDragging.current || !containerRef.current) return;
      const containerRect = containerRef.current.getBoundingClientRect();
      const newWidth = e.clientX - containerRect.left;

      if (newWidth >= 200 && newWidth <= containerRect.width - 100) {
        setLeftColumnWidth(newWidth); // Update left column width in real-time
      }
    };

    const handleMouseUp = () => {
      if (isDragging.current) {
        isDragging.current = false; // End dragging
      }
    };

    // Add event listeners when component mounts
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    // Clean up event listeners when component unmounts
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [containerRef, setLeftColumnWidth]); // Dependencies

  return <div className="resize-bar" onMouseDown={handleMouseDown}></div>;
};

export default DragColumnResizer;

